module.exports = __webpack_public_path__ + "img/studio_wall.38b34543.png";